import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';
import { RegisterFormCompanyComponent } from '../../main/register/register-form-company/register-form-company.component';
import { RegisterFormNaturalPersonComponent } from '../../main/register/register-form-natural-person/register-form-natural-person.component';
import { GetCandidate } from 'src/app/models/candidate/get-candidate';
import { CandidateService } from 'src/app/services/candidate.service';
import { AuthService } from 'src/app/services/auth.service';
import { AlertService } from 'src/app/services/alert.service';
import { GetAddress } from 'src/app/models/security/register-request';
import { UserService } from 'src/app/services/user.service';
import { UserRoleIds } from 'src/app/models/security/user-role-enum';

@Component({
    selector: 'app-my-account-candidates',
    templateUrl: './my-account-candidates.component.html',
    styles: [],
    standalone: true,
    imports: [CarouselComponent, CommonModule, RegisterFormNaturalPersonComponent]
})
export class MyAccountCandidatesComponent implements OnInit {

  isLoading:boolean = false;
  isFound:boolean = false;
  candidate: GetCandidate | null | undefined = null;
  addresses: GetAddress[] = [];

  authService = inject(AuthService);
  alertService = inject(AlertService);
  userService = inject(UserService);

  typePerson: number = UserRoleIds.Member;
  rolesId = UserRoleIds;

  constructor() { }

  ngOnInit(): void {
    this.getCandidateData();
  }

  getCandidateData(): void{
    const userId: number = this.authService.getUserId() || 0;

    this.isLoading = true;

    this.userService.getCandidate(userId).subscribe({
      next: (res) => {
        this.candidate = res;
        if(res){
          this.isFound = true;
          this.getAddresses();
        }
      },
      error: (err) => {
        if(err){
          this.alertService.showErrorAlert(err[0]);
        }else{
          this.alertService.showErrorAlert('Error al consultar la información de la cuenta');
        }
      }
    }).add( () => {
      this.isLoading = false;
    }) ;
  }

  getAddresses(){
    const userId: number = this.authService.getUserId() || 0;

    this.isLoading = true;

    this.userService.getAddresses(userId).subscribe({
      next: (res) => {
        this.addresses = res;
      },
      error: (err) => {
        if(err){
          this.alertService.showErrorAlert(err[0]);
        }else{
          this.alertService.showErrorAlert('Error al consultar las direcciones de la cuenta');
        }
      }
    }).add( () => {
      this.isLoading = false;
    }) ;
  }

  savedCatcher(succeded: boolean){
    if(succeded){
      this.getCandidateData();
    }
  }
}
